import { Router as VueRouter } from 'vue-router'
import Router from 'src/router'

export let router: VueRouter

export default async ({ app }) => {
  router = await Router()
  app.use(router)
}
